<div class="time-window" *ngIf="dateRange[0] && isLocationSet">
  <!--  <bs-datepicker-inline id="pickupRange" [bsValue]="pickupDateRange" [minDate]='currentDate'></bs-datepicker-inline>-->
  <!--  <ngx-daterangepicker></ngx-daterangepicker>-->
  <div style="display: flex; flex-direction: row; flex-wrap: wrap">
    <div class="calendar-box" style="flex: 0 0 290px">
      <div class="mb-2">
        <div
          [tooltipDisabled]="dateRange[0] && dateRange[0] != (dateRange[1] || dateRange[0])"
          pTooltip="Select multiple days for a cheaper price"
        >
          <p-calendar
            id="calendar"
            name="calendar"
            *ngIf="dateRange"
            [showOtherMonths]="true"
            [selectOtherMonths]="true"
            [style]="{ width: '99%' }"
            [inputStyle]="{ width: '100%', cursor: 'pointer' }"
            [inline]="true"
            [minDate]="minDate"
            [(ngModel)]="dateRange"
            (ngModelChange)="setTimes()"
            selectionMode="range"
            [disabled]="disabled"
          >
            <ng-template pTemplate="date" let-date>
              <span [ngClass]="getDateClass(date)">{{ date.day }}</span>
            </ng-template>
          </p-calendar>
          <div class="select-next-date" *ngIf="!dateRange[1]">
            Select latest date for {{ isPickup ? 'collection' : 'delivery' }}
          </div>
        </div>
      </div>
    </div>
    <div style="flex: 1; min-width: 250px">
      <table>
        <tr>
          <td valign="top">
            <div class="earliest-circle"></div>
          </td>
          <td>
            <div style="margin-bottom: 5px" class="mb-2">
              Earliest {{ isPickup ? 'Collection' : 'Delivery' }}
            </div>
            <!-- time picker -->
            <div class="mb-4" style="display: flex; flex-direction: row">
              <div style="flex-shrink: 1">
                <div class="date-label">{{ getDateDesc(0) }}:</div>
              </div>
              <div style="flex-grow: 1">
                <p-dropdown
                  [options]="times"
                  [(ngModel)]="earliestTime"
                  [style]="{ width: '100px' }"
                  *ngIf="times"
                  styleClass="timepicker"
                  appendTo="body"
                  [autoWidth]="false"
                  [disabled]="disabled"
                ></p-dropdown>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td valign="top">
            <div class="latest-circle"></div>
          </td>
          <td>
            <div *ngIf="dateRange[1]; else noEndDate">
              <div style="margin-bottom: 5px">
                Latest {{ isPickup ? 'Collection' : 'Delivery' }}
              </div>

              <!-- time picker -->
              <div style="display: flex; flex-direction: row">
                <div style="flex-shrink: 1">
                  <div class="date-label">{{ getDateDesc(1) }}:</div>
                </div>
                <div style="flex-grow: 1">
                  <p-dropdown
                    [options]="times"
                    [(ngModel)]="latestTime"
                    [style]="{ width: '100px' }"
                    *ngIf="times"
                    styleClass="timepicker"
                    appendTo="body"
                    [autoWidth]="false"
                    [disabled]="disabled"
                  ></p-dropdown>
                </div>
              </div>
            </div>
            <ng-template #noEndDate
              >Select latest {{ isPickup ? 'Collection' : 'Delivery' }} date in
              calendar</ng-template
            >
          </td>
        </tr>
        <tr
          *ngIf="
            dateRange[0] &&
            dateRange[1] &&
            (!isPickup || locationForm.controls.pickUpWindowUnderLimit.valid)
          "
        >
          <td colspan="2">
            <div style="flex-shrink: 1" class="mt-4">
              <div
                class="summary-title"
                [innerHtml]="getSummaryText(earliestDateTime, latestDateTime)"
              ></div>
            </div>
          </td>
          <td>&nbsp;</td>
        </tr>
        <!-- don't show lead time in delivery section -->
        <tr
          *ngIf="
            isPickup &&
            dateRange[0] &&
            dateRange[1] &&
            locationForm.controls.pickUpWindowUnderLimit.valid
          "
        >
          <td class="info-col-icon">
            <i [ngClass]="leadTimeIcon" pTooltip="{{ leadTimeInfo }}"></i>
          </td>
          <td class="info-col">
            <div style="flex-shrink: 1; vertical-align: baseline">
              <div [innerHTML]="leadTimeText"></div>
            </div>
          </td>
        </tr>
        <tr *ngIf="dateRange[0] && dateRange[1]">
          <td class="info-col-icon"><i [ngClass]="windowIcon" pTooltip="{{ windowInfo }}"></i></td>
          <td class="info-col">
            <div style="flex-shrink: 1; vertical-align: baseline">
              <div [innerHTML]="timeError ? windowInfo : windowText"></div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>

<div
  class="error-container mb-2"
  *ngIf="
    dateRange[0] && dateRange[1] && !locationForm.controls.pickUpWindowUnderLimit.valid && isPickup
  "
>
  <div class="flex grid-gap-10">
    <div class="flex-shrink-1 warning-icon">
      <i class="fa fa-warning" style="color: #f97316"></i>
    </div>
    <div class="flex-grow-1">
      <div class="warning-title">Need Additional Booking Capacity?</div>
      <div class="warning-text">
        This booking window has now reached capacity. Need to place more bookings? Please contact
        your Account Manager and we'll review your requirements and explore how we can accommodate
        the additional volume
      </div>
    </div>
  </div>
</div>
